const simpleHash = async (str: string): Promise<string> => {
  try {
    if (typeof crypto !== 'undefined' && crypto.subtle) {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      return hash;
    }
  } catch (error) {
  }
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  const fallbackHash = Math.abs(hash).toString(16);
  return fallbackHash;
};

class RequestHelper {
  _token = "";
  _secretKey = "m9v4qj1xyd23t2ksc7zpo93";
  _enableSignature = true;

  setSecretKey = (key: string) => {
    this._secretKey = key;
  };

  setSignatureEnabled = (enabled: boolean) => {
    this._enableSignature = enabled;
  };

  setToken = (t: string) => {
    this._token = t;
    if (typeof window === "undefined") return;
    localStorage.setItem("token", t);
  };
  getToken = () => {
    if (this._token) return this._token;
    const fromSaved = localStorage.getItem("token");
    if (fromSaved) {
      this._token = fromSaved;
      return fromSaved;
    }
    return "";
  };

  host = "http://localhost:3000";
  setHost = (h: string) => {
    this.host = h;
  };
  h = (path = "") => {
    let url = this.host + path;
    if (this.host.endsWith("/") && path.startsWith("/")) {
      url = url.replace("//", "/");
    }
    return url;
  };

  generateSignature = async (
    data: any
  ): Promise<string> => {
    const timestamp = Date.now().toString();
    const allData: { [key: string]: any } = {
      ...data,
      timestamp,
    };

    const sortedKeys = Object.keys(allData).sort();
    const signatureString = sortedKeys
      .filter(key => allData[key] !== undefined)
      .map(key => `${key}=${typeof allData[key] === 'object' ? JSON.stringify(allData[key]) : allData[key]}`)
      .join('&');

    const stringToHash = `${signatureString}&secret=${this._secretKey}`;

    const signature = await simpleHash(stringToHash);

    return `${signature}:${timestamp}`;
  };

  makeHeader = async (
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    data?: any,
    isUpload = false
  ) => {
    let token = this.getToken();
    let headers = new Headers({
      Accept: "application/json, text/plain, */*",
    });
    if (token) headers.set("Authorization", token);

    if (method === "POST" || method === "PUT")
      headers.set("Content-Type", "application/json");
    if (isUpload) {
      headers.set("Content-Type", "application/json");
    }

    if (this._enableSignature) {
      const signature = await this.generateSignature(data);
      headers.set("X-Signature", signature);
    }
    return headers;
  };
  querify = (url: string, queryObject?: { [key: string]: any }) => {
    let newUrl = url;
    if (!queryObject) return newUrl;
    let queryString = "";
    for (let key in queryObject) {
      queryString += queryString.length > 0 ? "&" : "";
      queryString += `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
    }
    newUrl += "?" + queryString;
    return newUrl;
  };

  returnFetchResponse = async (
    response: Response
  ): Promise<{ headers: Headers; data: any }> => {
    console.log("response.headers", response.headers.get("content-type"));
    if (response.headers.get("content-type") === "application/pdf") {
      const blob = await response.blob();
      return {
        headers: response.headers,
        data: blob,
      };
    }
    let data = await response.text();
    try {
      data = JSON.parse(data);
    } catch (_) { }
    return {
      headers: response.headers,
      data: data,
    };
  };

  call = async (
    URL: string,
    method: string,
    params?: { [key: string]: any },
    query?: { [key: string]: any },
    body = {}
  ) => {
    let url = this.h(URL);
    if (query) url = this.querify(url, query);
    if (params) {
      for (let key in params) {
        const value = params[key];
        url = url.replace(":" + key, encodeURIComponent(value ?? ""));
      }
    }

    // Prepare data for signature - must match backend logic in verifySignature.ts
    // Backend combines: (query/body) + params
    let dataForSignature: any = {};
    const methodUpper = method.toUpperCase();

    if (["GET", "DELETE"].includes(methodUpper)) {
      // For GET/DELETE: combine query + params
      if (query && Object.keys(query).length > 0) {
        dataForSignature = { ...dataForSignature, ...query };
      }
    } else {
      // For POST/PUT/PATCH: combine body + params
      if (body && Object.keys(body).length > 0) {
        dataForSignature = { ...dataForSignature, ...body };
      }
    }

    // // Always add route parameters if present (matches backend logic)
    // if (params && Object.keys(params).length > 0) {
    //   dataForSignature = { ...dataForSignature, ...params };
    // }

    const res = await fetch(url, {
      method: methodUpper,
      headers: await this.makeHeader(
        ["GET", "DELETE"].includes(methodUpper) ? "GET" : "POST",
        dataForSignature,
      ),
      body: ["GET", "DELETE"].includes(methodUpper)
        ? undefined
        : JSON.stringify(body),
    });
    return await this.returnFetchResponse(res);
  };
}

export default new RequestHelper();
